export default {
  'verificationcheck.verifycode': 'ВЕРИФИКАЦИОННЫЙ КОД',
  'verificationcheck.gotoprofile': 'Перейти к профилю',
  'verificationcheck.entercode': 'введите код подтверждения',
  'verificationcheck.maintext':
    'Чтобы продолжить, введите код подтверждения здесь, код был отправлен',
  'verificationcheck.continuetext': '.',
  'verificationcheck.evaluate': 'ОЦЕНИТЬ',
  'verificationcheck.resendcode': 'Нажмите, чтобы отправить код ещё раз',
};
